import React, { useEffect, useState } from "react";
import HomeDesktop from "./HomeDesktop";
import HomeMobile from "./HomeMobile";
import "../styles/Home.css";

const detectMobile = () => {
  if (typeof navigator !== "undefined" && navigator.userAgent) {
    if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      return true;
    }
  }

  if (typeof window !== "undefined") {
    return window.innerWidth <= 900;
  }

  return false;
};

const Home = () => {
  const [isMobile, setIsMobile] = useState(() => detectMobile());

  useEffect(() => {
    const onResize = () => setIsMobile(detectMobile());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return isMobile ? <HomeMobile /> : <HomeDesktop />;
};

export default Home;
